module.exports = __webpack_public_path__ + "images/chevron_white.svg";